export default __webpack_public_path__ + "static/media/camerea.c5818980.jpg";